module.exports = require("bowser");


//////////////////
// WEBPACK FOOTER
// external "bowser"
// module id = 124
// module chunks = 0